exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".file-uploader-container {\n\n  direction: rtl;\n  text-align: right;\n\n}\n.info-message\n{\n  padding-top: 20px;\n  color: #0b6d77;\n  font-size: 12px;\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/app/component/shared/file-upload/file-upload.style.css
// module id = 998
// module chunks = 3